import type { api, DuelTournamentView } from './api.js';

export type DirectDuelSummary = Awaited<ReturnType<typeof api.duels>>[number];

export type DuelAttention = {
  readonly total: number;
  readonly invitations: number;
  readonly games: number;
  readonly waiting: number;
};

export const duelNeedsAction = (duel: Pick<DirectDuelSummary, 'canAccept' | 'canPlay'>): boolean =>
  duel.canAccept || duel.canPlay;

export const tournamentNeedsAction = (
  duel: Pick<DuelTournamentView, 'isParticipant' | 'canPlay'>,
): boolean => duel.isParticipant && duel.canPlay;

export const duelAttention = (
  direct: readonly DirectDuelSummary[] = [],
  tournaments: readonly DuelTournamentView[] = [],
): DuelAttention => {
  const invitations = direct.filter((duel) => duel.canAccept).length;
  const directGames = direct.filter((duel) => duel.canPlay && !duel.canAccept).length;
  const tournamentGames = tournaments.filter(tournamentNeedsAction).length;
  const waitingDirect = direct.filter(
    (duel) => ['OPEN', 'ACCEPTED'].includes(duel.status) && !duelNeedsAction(duel),
  ).length;
  const waitingTournaments = tournaments.filter(
    (duel) => duel.isParticipant && ['OPEN', 'ACCEPTED'].includes(duel.status) && !duel.canPlay,
  ).length;
  return {
    total: invitations + directGames + tournamentGames,
    invitations,
    games: directGames + tournamentGames,
    waiting: waitingDirect + waitingTournaments,
  };
};
